import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'reverse'
})
export class ReversePipe implements PipeTransform {

    transform(value) {
        return value.slice().reverse();
    }
}



// WEBPACK FOOTER //
// ./src/app/brightserve/pipes/reverse.pipe.ts